<template>
  <div class="my-tab2-box">
    <slot></slot>
  </div>
</template>
<script>
// <Tr1></Tr1>
export default {
  name: 'TabBox2',
  props: {

  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.my-tab2-box{
  // width: 131px;

}
</style>
